// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Müşteriler',
  subtitle: 'Tüm müşteri bilgilerini yönetin',
  addNew: 'Yeni Müşteri Ekle',
  editCustomer: 'Müşteri Düzenle',
  searchPlaceholder: 'Müşteri ara...',
  filterAll: 'Tümü',
  filterActive: 'Aktif Müşteriler',
  filterInactive: 'Pasif Müşteriler',
  resultsFound: 'müşteri bulundu',
  noCustomers: 'Henüz müşteri bulunmuyor',
  noCustomersFiltered: 'Arama veya filtre kriterlerine uygun müşteri bulunamadı',
  name: 'Ad Soyad',
  email: 'E-posta',
  phone: 'Telefon',
  address: 'Adres',
  notes: 'Notlar',
  password: 'Şifre',
  companies: 'Şirketler',
  companiesMultiple: 'Şirketler (Birden çok seçebilirsiniz)',
  noCompanies: 'Henüz şirket bulunmuyor',
  companiesSelected: 'şirket seçildi',
  newCompany: 'Yeni Şirket Ekle',
  passwordChange: 'Değiştirmek için yeni şifre girin',
  passwordRequired: 'Müşteri giriş şifresi',
  passwordHint: 'Şifreyi değiştirmek istemiyorsanız boş bırakın',
  saving: 'Kaydediliyor...',
  saveButton: 'Ekle',
  updateButton: 'Güncelle',
  cancelButton: 'İptal',
  selectedCount: 'müşteri seçildi',
  activateSelected: 'Aktif Yap',
  deactivateSelected: 'Pasif Yap',
  deleteSelected: 'Seçili Müşterileri Sil',
  tableCustomer: 'Müşteri',
  tableContact: 'İletişim',
  tableCompany: 'Şirket',
  tableAddress: 'Adres',
  tableStatus: 'Durum',
  tableActions: 'İşlemler',
  statusActive: 'Aktif',
  statusInactive: 'Pasif',
  activate: 'Aktif yap',
  deactivate: 'Pasif yap',
  view: 'Görüntüle',
  edit: 'Düzenle',
  resetPassword: 'Parola Sıfırla',
  delete: 'Sil',
  customerDetails: 'Müşteri Detayları',
  detailName: 'Ad Soyad',
  detailEmail: 'E-posta',
  detailPhone: 'Telefon',
  detailCompanies: 'Şirketler',
  detailAddress: 'Adres',
  detailNotes: 'Notlar',
  detailRegDate: 'Kayıt Tarihi',
  close: 'Kapat',
  newCompanyTitle: 'Yeni Şirket Ekle',
  companyName: 'Şirket Adı',
  companyPhone: 'Telefon',
  companyEmail: 'E-posta',
  companyWebsite: 'Website',
  companyTaxNumber: 'Vergi Numarası',
  companyAddress: 'Adres',
  companyDescription: 'Açıklama',
  companyAddButton: 'Şirket Ekle',
  resetPasswordTitle: 'Parola Sıfırla',
  resetPasswordDesc: 'müşterisi için yeni parola belirleyin.',
  newPassword: 'Yeni Parola',
  newPasswordPlaceholder: 'En az 6 karakter',
  newPasswordHint: 'Parola en az 6 karakter olmalıdır',
  sendEmail: 'Parolayı e-posta ile gönder',
  resetButton: 'Parolayı Sıfırla',
  errorFetch: 'Müşteriler getirilemedi',
  errorFetchCompanies: 'Şirketler getirilemedi',
  errorPasswordRequired: 'Yeni müşteri için şifre gereklidir',
  errorOperation: 'İşlem başarısız',
  errorCompanyAdd: 'Şirket eklenemedi',
  errorDelete: 'Müşteri silinemedi',
  errorSelectToDelete: 'Lütfen silmek için en az bir müşteri seçin',
  errorSession: 'Oturum açmanız gerekiyor.',
  errorSessionExpired: 'Oturum süreniz dolmuş.',
  errorConnection: 'Bağlantı hatası oluştu',
  errorPasswordMinLength: 'Parola en az 6 karakter olmalıdır',
  errorSelectToUpdate: 'Lütfen güncellemek için en az bir müşteri seçin',
  confirmDelete: 'Bu müşteriyi silmek istediğinizden emin misiniz?',
  confirmDeleteMultiple: '{{count}} müşteriyi silmek istiyor musunuz?',
  confirmActivateMultiple: '{{count}} müşteriyi aktif yapmak istiyor musunuz?',
  confirmDeactivateMultiple: '{{count}} müşteriyi pasif yapmak istiyor musunuz?',
  successDeleted: '{{count}} müşteri başarıyla silindi',
  successUpdated: '{{count}} müşteri başarıyla güncellendi',
  successExport: 'Müşteriler başarıyla export edildi',
  successPasswordReset: 'Parola başarıyla sıfırlandı',
  exportFileName: 'musteriler_',
  exportSheetName: 'Müşteriler',
  exportColumns: {
    name: 'Müşteri Adı',
    email: 'E-posta',
    phone: 'Telefon',
    address: 'Adres',
    companies: 'Şirketler',
    status: 'Durum',
    createdAt: 'Oluşturulma Tarihi'
  }
};
